const AboutPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
          Tentang <span className="text-indigo-600">Marikerja</span>
        </h1>
        <p className="mt-3 text-gray-600 max-w-2xl mx-auto">
          Platform lowongan pekerjaan yang membantu pencari kerja menemukan
          peluang terbaik sesuai minat, keahlian, dan tujuan karier.
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-2">
        <div className="space-y-5 text-gray-700 leading-relaxed">
          <p>
            <strong>Marikerja</strong> adalah website lowongan pekerjaan yang
            dirancang untuk memudahkan pencari kerja dalam menemukan informasi
            pekerjaan yang relevan dan terpercaya. Kami menyediakan berbagai
            lowongan dari beragam bidang dan lokasi.
          </p>

          <p>
            Dengan antarmuka yang sederhana dan mudah digunakan, Marikerja
            bertujuan untuk mempercepat proses pencarian kerja tanpa harus
            menghabiskan waktu berjam-jam untuk mencari informasi lowongan.
          </p>

          <p>
            Kami percaya bahwa setiap orang berhak mendapatkan akses terhadap
            peluang kerja yang sesuai dengan potensi dan impiannya.
          </p>
        </div>

        <div className="bg-gray-50 border rounded-2xl p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Kenapa Memilih Marikerja?
          </h3>

          <ul className="space-y-3 text-sm text-gray-700">
            <li className="flex gap-2">
              <span className="text-indigo-600 font-bold">✓</span>
              Lowongan kerja terkurasi dan terpercaya
            </li>
            <li className="flex gap-2">
              <span className="text-indigo-600 font-bold">✓</span>
              Pencarian pekerjaan cepat dan mudah
            </li>
            <li className="flex gap-2">
              <span className="text-indigo-600 font-bold">✓</span>
              Informasi gaji, lokasi, dan jenis pekerjaan yang jelas
            </li>
            <li className="flex gap-2">
              <span className="text-indigo-600 font-bold">✓</span>
              Tampilan responsif di semua perangkat
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
